import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Loader2, Star, IndianRupee, GraduationCap } from "lucide-react";
import { toast } from "sonner";

export default function Tutors() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/tutors").then((r) => setList(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="max-w-3xl mb-10">
        <div className="overline mb-3">Tutor Marketplace</div>
        <h1 className="text-4xl sm:text-5xl font-semibold text-brand-blue leading-tight">Vetted tutors, warm humans.</h1>
        <p className="mt-4 text-lg text-brand-muted">Subject experts across CBSE, ICSE, IB, Cambridge, Montessori and skill-based learning.</p>
      </div>

      {!list ? <Loader2 className="animate-spin text-brand-green mx-auto" /> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((t) => (
            <div key={t.id} data-testid={`tutor-card-${t.id}`} className="surface surface-hover p-6">
              <div className="flex gap-3 items-center mb-3">
                <div className="w-12 h-12 rounded-full bg-brand-blue text-white font-heading font-semibold flex items-center justify-center">{t.name.split(" ").map(n => n[0]).slice(0,2).join("")}</div>
                <div>
                  <h3 className="text-lg font-semibold text-brand-blue">{t.name}</h3>
                  <div className="text-xs text-brand-muted">{t.board} • {t.experience_years} yrs</div>
                </div>
              </div>
              <p className="text-sm text-brand-muted line-clamp-2">{t.bio}</p>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {t.subjects.map((s) => <span key={s} className="chip">{s}</span>)}
              </div>
              <div className="mt-5 flex items-center justify-between text-sm">
                <span className="flex items-center gap-1 text-brand-orange"><Star size={14} fill="currentColor" /> {t.rating}</span>
                <span className="flex items-center gap-1 text-brand-blue font-medium"><IndianRupee size={13} /> {t.hourly_rate}/hr</span>
              </div>
              <button data-testid={`tutor-book-${t.id}`} onClick={() => toast.success(`Demo booked with ${t.name}. We'll email you.`)} className="btn-primary mt-5 w-full"><GraduationCap size={14} /> Book demo class</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
